module.exports = __webpack_public_path__ + "resources/img/img_netbackup_m_en.02e9f64b3584e5d612d5d073491a6c93.png";